import { useMemo, useState } from "react";
import { siteData } from "./data/intelligence";
import { filterProjects } from "./lib/radar";
import type { Filters } from "./lib/types";
import { Hero } from "./components/Hero";
import { Methodology } from "./components/Methodology";
import { NoiseWatchlist } from "./components/NoiseWatchlist";
import { ProjectArchive } from "./components/ProjectArchive";
import { RadarCards } from "./components/RadarCards";
import { RadarControls } from "./components/RadarControls";
import { RadarTable } from "./components/RadarTable";
import { RiskAlerts } from "./components/RiskAlerts";
import { SafetyChecklist } from "./components/SafetyChecklist";
import { SiteHeader } from "./components/SiteHeader";

const defaultFilters: Filters = { query: "", rating: "all", risk: "all" };

function ResearchNote() {
  return <div className="panel"><h2>研究边界</h2><p>{siteData.disclaimer}</p></div>;
}

export default function App() {
  const [filters, setFilters] = useState<Filters>(defaultFilters);
  const [openProjects, setOpenProjects] = useState<Set<string>>(new Set(["doppler-xdp"]));
  const projects = useMemo(() => filterProjects(siteData.projects, filters), [filters]);

  function toggleProject(slug: string) {
    setOpenProjects((current) => {
      const next = new Set(current);
      next.has(slug) ? next.delete(slug) : next.add(slug);
      return next;
    });
  }

  function openProjectFromRadar(slug: string) {
    setOpenProjects((current) => new Set(current).add(slug));
    document.getElementById(`archive-${slug}`)?.scrollIntoView?.({ block: "start" });
  }

  return <div className="app-shell">
    <SiteHeader />
    <main>
      <Hero />
      <section id="overview" className="section-block"><ResearchNote /></section>
      <section id="radar" className="section-block">
        <RadarControls filters={filters} onChange={setFilters} onClear={() => setFilters(defaultFilters)} />
        {projects.length > 0 ? <><RadarTable projects={projects} openProjects={openProjects} onActivate={openProjectFromRadar} /><RadarCards projects={projects} openProjects={openProjects} onActivate={openProjectFromRadar} /></> : <div className="empty-state" role="status"><p>没有符合当前条件的项目</p><button type="button" onClick={() => setFilters(defaultFilters)}>清除筛选</button></div>}
      </section>
      <section id="archives" className="section-block"><ProjectArchive projects={projects} openProjects={openProjects} onToggle={toggleProject} /></section>
      <section id="alerts" className="section-block"><RiskAlerts /><NoiseWatchlist /></section>
      <SafetyChecklist />
      <section id="methodology" className="section-block"><Methodology /></section>
    </main>
  </div>;
}
